import { render, staticRenderFns } from "./LoginRouterLink.vue?vue&type=template&id=81caab98"
import script from "./LoginRouterLink.vue?vue&type=script&lang=js"
export * from "./LoginRouterLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports